import { useEffect, useState } from "react";
import { DataTable } from "../../../../Component/Common/Components/DataTable/DataTable";
import { DataPageSubmissionStatus, VaSubmissionTypes } from "../../../../Component/Model/Enum/BEE123Enums";
import { EntriesPerPage } from "../../../../Component/Model/Table/Table";
import { VerificationDataPageSubmission } from "../../../../Component/Model/Dto/VerificationAgency/VerificationDataPageSubmission";
import { VerificationDataPageSubmissionService } from "../../../../Component/Api/VerificationAgency/VerificationDataPageSubmission/VerificationDataPageSubmissionService";
import { DataPagesTableMapper } from "../IncomingDataPagesTable";
import { IncomingDataPageModal } from "../IncomingDataPageModal";

interface IProps {
    status: DataPageSubmissionStatus;
}
export const DataPageAccessRequests = (props: IProps) => {

    const [verificationDataPageAccessRequestData, setVerificationDataPageAccessRequestData] = useState<VerificationDataPageSubmission.DataPagesSearchResult[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [entriesPerPage, setEntriesPerPage] = useState<EntriesPerPage>({ defaultValue: 10 });
    const [pageNumber, setPageNumber] = useState<number>(1);
    const [searchValue, setSearchValue] = useState<string>('');
    const [filteredItemsCount, setFilteredItemsCount] = useState<number>(0);
    const [totalItemsCount, setTotalItemsCount] = useState<number>(0);
    const [selectedRequestId, setSelectedRequestId] = useState<number>(0);
    const [displayIncomingSubmissionModal, setDisplayIncomingSubmissionModal] = useState<boolean>(false);
    const submissionType = VaSubmissionTypes.Request_Access;


    const pendingDataPageSubmissionSearchRequest: VerificationDataPageSubmission.SearchRequest = {
        columnSortOptions: [],
        pageNumber: pageNumber,
        pageSize: entriesPerPage.defaultValue as number,
        searchValue: searchValue,
        submissionType: submissionType,
        status: props.status
    };

    const entriesPerPageChanged = (entriesPerPage: number) => {
        setEntriesPerPage({ defaultValue: entriesPerPage });
        setPageNumber(1);
    }

    const pageNumberChanged = (pageNumber: number) => {
        setPageNumber(pageNumber);
    }

    const searchValueChanged = (value: string) => {
        setSearchValue(value);
    }

    const fetchData = async () => {
        setIsLoading(true);
        try {
            let response = await VerificationDataPageSubmissionService.SearchIncomingSubmissions(pendingDataPageSubmissionSearchRequest);
            setVerificationDataPageAccessRequestData(response.data.results);
            setFilteredItemsCount(response.data.filteredItemsCount);
            setTotalItemsCount(response.data.totalItemsCount);
        } catch (error) { 
            console.log(error);
        }
        finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [entriesPerPage, searchValue, pageNumber]);

    useEffect(() => {
        setPageNumber(1);
        setSearchValue('');
        setEntriesPerPage({ defaultValue: 10 });
    }, [ props.status]);


    const handleEdit = (requestId: number) => {
        setSelectedRequestId(requestId);
        setDisplayIncomingSubmissionModal(true);
    }
    
    const handleIncomingSubmissionModalCancel = () => {
        setSelectedRequestId(0);
        setDisplayIncomingSubmissionModal(false);
        fetchData();
    }

    const VerificationDataPageSubmissionTableData = DataPagesTableMapper(verificationDataPageAccessRequestData, VaSubmissionTypes.Request_Access, props.status, handleEdit);

    return (
        <>
            <DataTable
                key={props.status}
                table={VerificationDataPageSubmissionTableData}
                entriesPerPage={entriesPerPage}
                pageNumber={pageNumber}
                filteredItemsCount={filteredItemsCount}
                totalItemsCount={totalItemsCount}
                entriesPerPageChanged={entriesPerPageChanged}
                pageNumberChanged={pageNumberChanged}
                isLoading={isLoading}
                canSearch={true}
                searchValueChanged={searchValueChanged}
                manualSorting={true}
            />
             { displayIncomingSubmissionModal && 
                <IncomingDataPageModal 
                    id={selectedRequestId} 
                    showModal={displayIncomingSubmissionModal}
                    submissionType={submissionType}
                    status={props.status}
                    handleCancel={handleIncomingSubmissionModalCancel}  
                />
            }
        </>
    )
}
